"use strict";
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractPureComponent2 = exports.AbstractComponent2 = void 0;
/** @fileoverview type aliases for backwards-compatibility with @blueprintjs/core v4.x */
var abstractComponent_1 = require("./common/abstractComponent");
/** @deprecated use AbstractComponent */
Object.defineProperty(exports, "AbstractComponent2", { enumerable: true, get: function () { return abstractComponent_1.AbstractComponent; } });
var abstractPureComponent_1 = require("./common/abstractPureComponent");
/** @deprecated use AbstractPureComponent */
Object.defineProperty(exports, "AbstractPureComponent2", { enumerable: true, get: function () { return abstractPureComponent_1.AbstractPureComponent; } });
//# sourceMappingURL=deprecatedTypeAliases.js.map